import { useRef, useState, useEffect } from 'react';
import TextBoxControl from "../../../Controls/TextBoxControl"
import GridControl from "../../../Controls/GridControl"
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import {
	GetLocal,
	FetchService,
	SetLocal
} from "../../../Base/BaseControl";

export default function Index(props) {

	const [getServiceResult, setServiceResult] = useState(false);
	const [getPdf, setPdf] = useState('');
	const [showModal, setShowModal] = useState(false);
	const [getIPGType, setIPGType] = useState(null);

	useEffect(() => {
		var inputValue = {
			session: GetLocal('TradeSession')
		};
		FetchService("Owner/Trade/Request/ShowTradeToll", inputValue, ShowModernizationTollSuccess);
	}, []);

	const ShowModernizationTollSuccess = (ServiceResult) => {
		setServiceResult(ServiceResult.TradeTollList);
		setIPGType(ServiceResult.IPGType)
		SetLocal("IPGType",ServiceResult.IPGType)
	}

	const PaymentAction = (row) => {
		IPGPaymentRequest();
	}

	const ViewFish = (row) => {
		var inputValue = {
			session: GetLocal('TradeSession'),
			serialNumber: row.SerialNumber
		};
		FetchService("Owner/Trade/Report/ShowTradeChargesReport", inputValue, ShowTradeChargesReportSuccess);
	}

	const ShowTradeChargesReportSuccess = (ServiceResult) => {
		setPdf("data:application/pdf;base64," + ServiceResult);
		setShowModal(true)
	}

	const IPGPaymentRequest = () => {
		var inputValue = {
			session: GetLocal('TradeSession')
		};
		if (getIPGType === 1) {
			FetchService("Owner/Trade/Request/IPGPaymentRequestByNovin", inputValue, IPGPaymentRequestSuccess);
		} else if (getIPGType === 0) {
			FetchService("Owner/Trade/Request/IPGPaymentRequest", inputValue, IPGPaymentRequestSuccess);
		}
	}

	const IPGPaymentRequestSuccess = (ServiceResult) => {
		window.location = ServiceResult.RedirectURL + '&returnURL=' + window.location.protocol + '//' + window.location.host + '/Trade/ReturnFromIPG/'
	}

	return (
		<div>
			<GridControl
				data={getServiceResult}
				headers={["Year", "PayableAmount", "PaymentDeadline", "PaymentDate", "Status"]}
				customHeaders={{ "FromYear": "از سال", "ToYear": "تا سال", "PayableAmount": "مبلغ قابل پرداخت", "PaymentDate": "تاریخ پرداخت", "Status": "وضعیت", "ViewFish": "مشاهده فیش", "PaymentAction": "پرداخت" }}
				PaymentAction={PaymentAction}
				ViewFish={ViewFish}
			/>

			<Modal dialogClassName="modalUi" show={showModal} onHide={() => setShowModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title></Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<iframe src={getPdf} width="100%" style={{ height: "500px" }}></iframe>
				</Modal.Body>
				<Modal.Footer>
					<Button variant="danger" onClick={() => setShowModal(false)}>
						بستن
					</Button>
				</Modal.Footer>
			</Modal>
		</div>
	);
}
